<div fxLayout="column">
    <div fxFlex="0 0 calc(100vh-70px)" fxLayout="column">
        <div fxLayout="row">
            <div *ngIf="selectedCategory" fxFlex="1 1 auto">
                <button mat-button class="risk-manager-menu-button" (click)="onDashboard()">
                    <mat-icon>navigate_before</mat-icon>
                    <span>Dashboard</span>
                </button>
            </div>
            <div *ngIf="selectedCategory && selectableCategories" fxFlex="1 1 auto">
                <button mat-button class="risk-manager-menu-button" [matMenuTriggerFor]="categories">{{selectedCategory.label}}</button>
                <mat-menu #categories="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item *ngFor="let category of selectableCategories" (click)="showCategory(category)">{{category.label}}</button>
                </mat-menu>
            </div>
            <div *ngIf="selectedCategory && selectableSubcategories" fxFlex="1 1 auto"  >
                <button mat-button class="risk-manager-menu-button" [matMenuTriggerFor]="subcategories">{{selectedRiskGraphicalConfig ? selectedRiskGraphicalConfig.subCategory : 'Select View...' }}</button>
                <mat-menu #subcategories="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item *ngFor="let subcategory of selectableSubcategories" (click)="showSubcategory(subcategory)">{{subcategory}} </button>
                </mat-menu>
            </div>
            <div *ngIf="selectedCategory && selectedSubcategory && selectableGraphicalConfigs.length > 1" fxFlex="1 1 auto">
                <button mat-button class="risk-manager-menu-button" [matMenuTriggerFor]="graphicalViews">{{selectedRiskGraphicalConfig ? selectedRiskGraphicalConfig.label : 'Select View...' }}</button>
                <mat-menu #graphicalViews="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item *ngFor="let graphicalConfig of selectableGraphicalConfigs" (click)="showConfig(graphicalConfig)">
                        <span [class]="'fa '+ getMenuIcon(graphicalConfig)"></span>
                        <span>{{graphicalConfig.label}}</span>
                    </button>
                </mat-menu>
            </div>
            <div fxFlex="1000 0 auto" fxLayoutAlign="stretch"></div>
            <!-- <div *ngIf="selectedCategory" fxFlex="1 1 auto" fxFlexAlign="end">
            <button mat-button class="risk-manager-menu-button" [matMenuTriggerFor]="usageTypes">{{selectedUsageType ? selectedUsageType : 'Select usage'}}</button>
            <mat-menu #usageTypes="matMenu" [overlapTrigger]="false">
                <button mat-menu-item *ngFor="let usageType of selectableRiskDataUsageTypes" (click)="changeUsageType(usageType)">{{usageType}}</button>
            </mat-menu>
        </div>
        <div *ngIf="selectedCategory" fxFlex="1 1 auto" fxFlexAlign="end">
            <button mat-button class="risk-manager-menu-button" (click)="pdfExport()">PDF Export</button>
        </div> -->
        </div>
        <app-dashboard-metric-bar #dashboardMetricBar fxFlex="1 2 auto" *ngIf="!selectedCategory"></app-dashboard-metric-bar>
        <!-- <app-risk-stress #riskStress fxFlex="1 2 auto" *ngIf="!selectedCategory && isStressSelected"></app-risk-stress> -->
        
        <div fxLayout="row" fxFlex="2 1 auto" *ngIf="selectedCategory" class="risk-manager-main">
            <!-- <div fxFlex="0 1 0%" class="height-bar"></div> -->
            <div fxFlex="1 1 100%" fxLayout="column" fxLayoutGap="10px">
                <div fxFlex="1 1 auto" class="liquitics-box">
                    <!-- <h3 *ngIf="selectedCategory">{{selectedCategory.label}}</h3> -->
                    <app-dashboard-metric-bar [selectedDashboardMetricCategory]="selectedCategory" [selectedSubType]="selectedSubType"></app-dashboard-metric-bar>
                </div>
                <div fxFlex="1 1 auto" fxLayout="row">
                    <div *ngIf="selectedCategory && selectableCategories" [fxHide.lt-xl]="true" fxFlex="1 5 auto">
                        <!-- <button mat-menu-item *ngFor="let category of selectableCategories" (click)="showCategory(category)">{{category.label}}</button> -->
                        <p-panelMenu [model]="categoryItems" [multiple]="false"></p-panelMenu>
                    </div>
                    <div fxLayout="column" fxFlex="5 1 auto">
                        <!-- <p-breadcrumb [model]="breadcrumbs"></p-breadcrumb> -->
                        <div *ngIf="additionalFilterValues && selectedAdditionalFilterValues">
                            <ng-container *ngFor="let filterValues of additionalFilterValues; let i=index; trackBy:trackByIndex">
                                <p-dropdown [options]="filterValues" [(ngModel)]="selectedAdditionalFilterValues[i]" (onChange)="filterValueChanged($event,i)"
                                    optionLabel="name" [placeholder]="additionalFilterLabels[i]"></p-dropdown>
                                <button pButton *ngIf="!additionalFilterRequireds[i]" type="button" (click)="clearFilterSelection(i)" icon="fa fa-close"></button>
                            </ng-container>
                        </div>
                        <div #chartwrapper class="chartwrapper liquitics-box" fxLayout="column">
                            <p-progressSpinner *ngIf="selectedRiskGraphicalConfig && !chartReady" class="spinner" animationDuration="2s"></p-progressSpinner>
                            <div id="riskchartdiv" class="chartdiv"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>